import { PropsWithChildren, ReactNode } from 'react';

import { useAuthentication } from 'app/hooks/useAuthentication';

type AfterEffectAuthProps = PropsWithChildren<{
  fallback?: ReactNode;
}>;

export const AfterEffectAuth = ({fallback, children}: AfterEffectAuthProps) => {
  const {state} = useAuthentication();

  if (state !== 'initialized') return <>{fallback}</>;

  return <>{children}</>;
};
